import React, { useRef, useEffect, useState } from "react";
import { Draggable } from "@fullcalendar/interaction";
import {
  Paper,
  Typography,
  Avatar,
  Box,
  Stack,
  Collapse,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  Dialog,
} from "@mui/material";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Visibility,
} from "@mui/icons-material";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { color } from "../../../StyleData/Config";
import LabourTimeLine from "./LabourTimeLine";
import { toast } from "react-toastify";

const LabourList = ({ open, handleOpen, selectedTask, workOrderDetail }) => {
  const [selectedLabour, setSelectedLabour] = useState([]);
  const [selectedLabourFullDetail, setSelLabourFullDetail] = useState([]);
  const [labourData, setLabourData] = useState([]);
  const [labourInfo, setLabourInfo] = useState({});
  const [timeLine, setTimeLine] = useState(false);

  useEffect(() => {
    getLabour();
  }, []);

  const getLabour = () => {
    const getLink = masterAPI["labourCraft"].link;
    axiosPrivate
      .get(`${getLink}`)
      .then((res) => {
        console.log(res);
        setLabourData(res.data.result);
      })
      .catch((e) => {
        setLabourData([]);
        console.log(e);
      });
  };

  const handleLabour = (e, detail) => {
    if (e.target.checked) {
      setSelectedLabour([...selectedLabour, e.target.value]);
      setSelLabourFullDetail([...selectedLabourFullDetail, detail]);
    } else {
      const filterSelectLabour = selectedLabour.filter(
        (fil) => fil !== e.target.value
      );
      const filterSelLabourFullDetail = selectedLabourFullDetail.filter(
        (fil) => fil.id !== e.target.value
      );
      setSelectedLabour(filterSelectLabour);
      setSelLabourFullDetail(filterSelLabourFullDetail);
    }
  };

  const handleAssigned = () => {
    if (workOrderDetail.id === undefined || selectedTask.length === 0) {
      toast.error("Please Select Workorder and Task");
    } else {
      const wo = [];
      let planHours = "1:00";
      let decimalPlanHours =
        Number(planHours.split(":")[0]) + Number(planHours.split(":")[1]) / 60;
      for (let i = 0; i < selectedTask.length; i++) {
        for (let j = 0; j < selectedLabourFullDetail.length; j++) {
          const wotData = {
            workOrderTaskId: selectedTask[i],
            labourId: selectedLabourFullDetail[j].labourId,
            workOrderId: workOrderDetail.id,
            craftId: selectedLabourFullDetail[j].craftId,
            quantity: 1,
            plannedHours: decimalPlanHours,
            workedHours: decimalPlanHours,
            rate: selectedLabourFullDetail[j].rateForRegularHors,
            cost:
              selectedLabourFullDetail[j].rateForRegularHors * decimalPlanHours,
          };
          console.log(wotData, i, j);
          wo.push(wotData);
        }
      }
      console.log("test", wo);
      const wotlink = masterAPI["workOrderTaskLabour"].bulkinsert;
      axiosPrivate
        .post(`${wotlink}`, wo)
        .then((res) => {
          console.log(res);
          setSelectedLabour([]);
          setSelLabourFullDetail([]);
          // toast.success("Sucessfully Updated")
        })
        .catch((e) => {
          console.log(e, "createwotaskLabour");
        });
    }
  };

  const handleTimeLine = () => {
    setLabourInfo({});
    setTimeLine(false);
  };

  return (
    <Box
      sx={{
        width: 350,

        p: 2,
        borderRadius: 2,
        border: "1px solid #ddd",
      }}
    >
      <Box sx={{ display: "flex", gap: "0.5rem", alignItems: "flex-end" }}>
        <Box
          sx={{
            display: "flex",
            gap: "0.5rem",
            alignItems: "center",
            cursor: "pointer",
            width: "70%",
          }}
          onClick={handleOpen}
        >
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Labour List
          </Typography>
          {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", width: "30%" }}>
          <Button
            onClick={handleAssigned}
            disabled={selectedLabour.length === 0}
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor:
                selectedLabour.length === 0
                  ? "default"
                  : color.TableButtonColor,
              "&:hover": {
                backgroundColor:
                  selectedLabour.length === 0 ? "default" : color.buttonDisable,
              },
            }}
          >
            Assign
          </Button>
        </Box>
      </Box>

      <Collapse in={open} sx={{ maxHeight: "50vh", overflowY: "auto", mt: 1 }}>
        <FormGroup>
          {labourData.map((event) => (
            <Paper
              variant="outlined"
              sx={{
                p: "0.2rem 1rem",
                mb: 1,
                display: "flex",
                alignItems: "center",
                borderRadius: 2,
                // backgroundColor: event.backgroundColor || 'primary.main',
                color: "black",
                borderLeft: `4px solid #1976d2`, // Left border highlight
                boxShadow: "none",
                userSelect: "none",
              }}
            >
              {/* <Stack direction="row" spacing={2} alignItems="flex-start">
             
                <Box>
                  <Typography fontWeight={500}>{event.title}</Typography>
                </Box>
              </Stack> */}

              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedLabour.includes(event.id)}
                    value={event.id}
                    onChange={(e) => {
                      handleLabour(e, event);
                    }}
                  />
                }
                label={
                  event.labourCode +
                  "-" +
                  event.labourName +
                  " (" +
                  event.craftName +
                  ")"
                }
                sx={{
                  "& .MuiFormControlLabel-label": {
                    // Target the label element
                    whiteSpace: "break-spaces",
                  },
                }}
              />
              <IconButton
                onClick={() => {
                  setLabourInfo(event);
                  setTimeLine(true);
                }}
              >
                <Visibility />
              </IconButton>
            </Paper>
          ))}
        </FormGroup>
      </Collapse>
      <Dialog
        open={timeLine}
        onClose={handleTimeLine}
        maxWidth={"xl"}
        children={
          <LabourTimeLine
            handleCloseClick={handleTimeLine}
            labourInfo={labourInfo}
            woDetail={workOrderDetail}
          />
        }
      />
    </Box>
  );
};

export default LabourList;
